export default "__VITE_ASSET__AzCNsQwG__"